import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { upItemType, addItemType } from "@/api/gmtool/packageCode";
export default {
  data: function data() {
    return {
      showDialog: false,
      paramsData: {
        id: '',
        name: "",
        type_id: ""
      },
      rules: {
        name: [{
          required: true,
          message: this.$t('pleaseInputItemName'),
          trigger: "blur"
        }],
        type_id: [{
          required: true,
          message: this.$t('pleaseInputItemType'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    open: function open(data) {
      console.log("data==", data);
      this.showDialog = true;
      this.paramsData = {
        id: data.id,
        name: data.name,
        type_id: data.type_id
      };
    },
    hide: function hide() {
      this.showDialog = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        host_name: "",
        host_flag: ""
      };
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          var reqFn = _this.paramsData.id ? upItemType : addItemType;
          reqFn(_this.paramsData).then(function (res) {
            if (res.code == 200) {
              _this.$message.success(_this.$t('operationSuccess'));

              _this.$emit("change");

              _this.showDialog = false; // this.resetForm("ruleForm");
            }
          });
        }
      });
    }
  }
};